import { Entity } from "./entity";
import { Company } from "./company";
import { PrincipalAuth } from "./principalAuth";

export class Principal extends Entity {
    CompanyId: number;
    Surname: string;
    Name: string;
    Taxcode: string;
    Mail: string;
    Phone: string;
    Username: string;
    Password: string;
    Role: string;
    Language?: string;
    AvatarId?: number;    
    Disabled?: Date | null;
    ApplicationForfetari: boolean;
    ApplicationConvenienza: boolean;
    ApplicationBudget: boolean;
    ApplicationEasyStart: boolean;
    UserCreation: boolean;
    ReportEnabled: boolean;
    Company?: Company;
    Error: string;
    
    PrincipalAuth: PrincipalAuth[];
    DescCompany?: string;
    
    // constructor(data?: any) {
    //     super()
    //     this.init(data);      
    // }

    // get State(): string | null {
    //     if (this.Disabled)
    //         return 'Disabled';
    //     return 'Enabled';
    // } 
    
    get agencyName(): string {
        if (this.PrincipalAuth && this.PrincipalAuth.length > 0)
            if (this.PrincipalAuth[0] && this.PrincipalAuth[0].Agency)
                return this.PrincipalAuth[0].Agency?.Name;
            else
                return '';
        else
            return '';
    } 

    static newItem(companyId: number): Principal {

        let item = new Principal();
        item.Id = 0;
        item.Disabled = null;
        item.CompanyId = companyId;
        item.ApplicationConvenienza = true;
        item.ApplicationForfetari = true;
        item.ApplicationBudget = true;
        return item;
    }
}

export class PrincipalSearchModel extends Entity {
    Surname?: string;
    Name?: string;
    Mail?: string;
    Username?: string;
    Role?: string;
    AgencyId?: number | null;
    Take?: number;
    QuerySurname: string | null;
    QueryId: number | null;
    PageDirection?: string;
}
